import { render, staticRenderFns } from "./Dibble.vue?vue&type=template&id=91508dc8&scoped=true"
import script from "./Dibble.vue?vue&type=script&lang=js"
export * from "./Dibble.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91508dc8",
  null
  
)

export default component.exports